import { NodeViewContent, NodeViewWrapper } from '@tiptap/react'
import React, { useRef, useEffect, useState } from 'react'
import katex from 'katex'
import { t } from 'i18next';
import global from "@/global";


export default (props) => {
  const { editor,node,updateAttributes } = props;
  let latexInlineRef = useRef(null);
  const [metaData, setMetaData] = useState('');
  const [latexHtmlData, setLatexHtmlData] = useState('');
  const [isHovered, setIsHovered] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const inputRef = useRef(null);

  let mInputPlaceHolder = useRef(t("AddATextEquation"));

  const handleChange = (event) => {
    setMetaData(event.target.value);
    // 实时更新html latex数据
    let html = katex.renderToString(event.target.value.replace(/\\begin{align\*?}/g, '\\begin{aligned}').replace(/\\end{align\*?}/g, '\\end{aligned}'), {
      throwOnError: false
    })
    setLatexHtmlData(html)
    if (window.isEdited === 1) {
      window.isEdited = 2
    }

    // 将latex格式数据存储到 data-metaData 中
    node.attrs.metaData = event.target.value
  };
  const inputDone = (event) => {
    if (event){
      event.stopPropagation();
    }
    latexInlineRef.current.querySelector('.popup').style.display = 'none'
    setIsSelected(false)
    setTimeout(() => {
      editor.chain().focus().setNodeSelection(props.getPos()).run();
    }, 90)

    updateAttributes({
      firstCreate:false,
      metaData:latexInlineRef.current.querySelector('#input').value
    })
  }
  const handleClick = () => {
    if (global.g_isPresentMode)return;

    latexInlineRef.current.querySelector('.popup').style.display = 'block'
    setIsSelected(true)
    latexInlineRef.current.querySelector('#input').focus();
  };
  const handleBlur = (event) => {
    latexInlineRef.current.querySelector('.popup').style.display = 'none'
    setIsSelected(false)
    // setTimeout(() => {
    //  editor.chain().focus().setNodeSelection(props.getPos()).run();
    // }, 120)
    inputDone(event);
  };

  const getBackgroundColor = () => {
    if (isSelected) {
      return 'var(--card-latex-block-background-hover-color)'
    }
    if (isHovered) {
      return 'var(--card-latex-block-background-hover-color)';
    }
    // return node.attrs?.metaData?.trim() === '' ? '#ebebeb' : '#fff';
    return 'var(--card-latex-block-background-color)'
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      inputDone();
    }
  }

  useEffect(() => {
    // 初始化latex
    setMetaData(node.attrs.metaData)
    if (node.attrs.firstCreate) {
      latexInlineRef.current.querySelector('.popup').style.display = 'block'
      setIsSelected(true)
      latexInlineRef.current.querySelector('#input').click();
      setTimeout(() => {
        latexInlineRef.current.querySelector('#input').focus()
      }, 10)
      node.attrs.firstCreate = false;
      updateAttributes({
        firstCreate:false
      })
    }

    // 初始化html latex
    let html = katex.renderToString(node.attrs.metaData.replace(/\\begin{align\*?}/g, '\\begin{aligned}').replace(/\\end{align\*?}/g, '\\end{aligned}'), {
      throwOnError: false
    })
    setLatexHtmlData(html)
    return () => {
    }
  }, [])


  return (
    <NodeViewWrapper className='latexInline' ref={latexInlineRef} data-id={node.attrs.id} style={{ display: node.attrs.ifhidden ? 'none' : 'inline-block' }}
    >
      <div
        className='htmlLatex'
        contentEditable={false}
        onClick={handleClick}
        style={{ textAlign: 'center', backgroundColor: getBackgroundColor(),paddingBottom:'2px' }}
        onMouseDown={(event) => {
          event.preventDefault();
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        dangerouslySetInnerHTML={{ __html: node.attrs.metaData.trim() === '' ? `<div style='color:#d2d2d2'>${mInputPlaceHolder.current}</div>` : latexHtmlData }}
      />
      <div className='popup' contentEditable={false} onBlur={handleBlur}>
        <textarea
            ref={inputRef}
          value={metaData}
          onChange={handleChange}
            style={{background:'transparent',color:'var(--text-color)'}}
          id="input" className="input" placeholder={t("Enter Latex")}
          onKeyDown={handleKeyDown}
        ></textarea>
        <button id="doneBtn" className="done-btn" onMouseDown={inputDone}>{t("Done")}</button>
      </div>
    </NodeViewWrapper>
  )
}